import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M37.78 10.83a19.984 19.984 0 0 0-3.637-4.973 19.985 19.985 0 0 0-4.972-3.636L15.08 15.08 2.22 29.17a19.99 19.99 0 0 0 3.636 4.972 19.99 19.99 0 0 0 4.972 3.636l14.09-12.86 12.86-14.09Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#D80027",
  d: "M5.857 34.143a20.132 20.132 0 0 0 2.674 2.246L36.389 8.53a20.116 20.116 0 0 0-4.92-4.92L3.611 31.47a20.115 20.115 0 0 0 2.246 2.674Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M5.857 5.857c-6.31 6.31-7.52 15.787-3.636 23.314L29.17 2.22C21.644-1.664 12.167-.452 5.857 5.857Zm28.286 28.286c6.31-6.31 7.52-15.787 3.636-23.314L10.83 37.78c7.527 3.885 17.004 2.674 23.314-3.636Z"
}, null, -1), i = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m10.658 6.086 1.08 3.322h3.492l-2.825 2.053 1.079 3.321-2.826-2.053-2.825 2.053 1.079-3.321-2.826-2.053H9.58l1.08-3.322Z"
}, null, -1), a = [
  n,
  c,
  s,
  i
];
function d(h, _) {
  return e(), l("svg", o, [...a]);
}
const p = { render: d };
export {
  p as default,
  d as render
};
